import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var StockTextContent = function(props) {
    var limitedStockText = props.limitedStockText, isSalesPaused = props.isSalesPaused;
    if (limitedStockText) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: limitedStockText
        });
    } else if (isSalesPaused) {
        return /*#__PURE__*/ _jsx(Typography, {
            variant: "paragraphSansRegular",
            color: Core.text.critical,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "G6G2FK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Out of stock"
                    }
                ]
            })
        });
    } else {
        return null;
    }
};
